import gql from 'graphql-tag';

export default gql`
    mutation EditLoadNotes($input: LoadNotesEdit) {
        editLoadNotes(input: $input) {
            errors
        }
    }
`;
